import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "wouter";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import HizmetSayfasi from "./pages/HizmetSayfasi";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";

const AdminPanel = lazy(() => import("./pages/AdminPanel"));

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/ozellikler" component={Features} />
      <Route path="/fiyatlar" component={Pricing} />
      <Route path="/giris" component={Login} />
      {/* Ücretsiz deneme/kayıt sayfası kaldırıldı (panel kurulumu sonra); sunucu 301 verir */}
      <Route path="/kayit"><Redirect to="/fiyatlar" replace /></Route>
      <Route path="/register"><Redirect to="/fiyatlar" replace /></Route>
      <Route path="/blog" component={Blog} />
      <Route path="/blog/:slug" component={BlogDetail} />
      <Route path="/admin">
        <Suspense fallback={<div className="min-h-screen bg-[#FFFDF7]" />}>
          <AdminPanel />
        </Suspense>
      </Route>
      {/* Hizmet sayfaları (veri tabanlı: hizmet_data.ts) */}
      <Route path="/facebook-reklam-hesabi-kiralama" component={HizmetSayfasi} />
      <Route path="/hizmetler/reklam-yonetimi" component={HizmetSayfasi} />
      <Route path="/hizmetler/e-ticaret-reklam-yonetimi" component={HizmetSayfasi} />
      <Route path="/hizmetler/seo-geo-hizmeti" component={HizmetSayfasi} />
      {/* Veri tabanlı hizmet sayfaları (hizmet_data + hizmet_ek_data) */}
      <Route path="/hizmetler/:slug" component={HizmetSayfasi} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <TooltipProvider>
      <Toaster />
      <Router />
    </TooltipProvider>
  );
}

export default App;
